import { appConfig } from 'config/customization';
import Device from 'constants/deviceSizes';
import { textInput } from 'constants/fonts';

import background from './background.jpg';

export default {
  container: {
    height: '100vh',
    display: 'flex'
  },
  lateralPanel: {
    height: '100%',
    overflow: 'auto',
    width: '70%',
    [Device.tablet_mobile]: {
      display: 'none'
    }
  },
  slide: {
    height: '75vh',
    background: `url(${background}) no-repeat`,
    backgroundColor: 'rgb(208,207,202)',
    backgroundPosition: 'bottom right',
    backgroundSize: 'auto 100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    paddingLeft: 30
  },
  slideText: {
    display: 'flex',
    flexDirection: 'column',
    width: 300,
    height: '90%',
    justifyContent: 'flex-end'
  },
  title: {
    fontSize: 28
  },
  actions: {
    height: '25vh',
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: appConfig.colors.white
  },
  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    width: '30%',
    height: '100%',
    overflow: 'auto',
    boxSizing: 'border-box',
    padding: '40px 30px',
    [Device.tablet_mobile]: {
      width: '100%'
    }
  },
  textInputSize: {
    fontSize: textInput
  }
};
